import Vue from "vue";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// import { ArticleItemSelect } from './ArticleItemsTreeviewSelect'

Vue.component("articles-treeview-select", {
    components: { Treeselect },
    props: [
        "code",
        "value",
        "language",
        "guid",
        "placeholder",
        "label",
        "isReadOnly",
        "valueCombining",
        "flat",
        "addany",
        "expanded",
        "containerClass",
        "samevaluedisplay",
        "autoDeselectAncestors",
        "autoSelectDescendants",
        "autoDeselectDescendants",
        "refValue"
    ],
    data() {
        return {
            loading: false,
            loadingText: window.labels.loading,
            myValue: this.value,
            articleId: 0,
            flatType: this.flat,
            expandedType: this.expanded,
            cclass: this.containerClass,
            autoDeselectParents: this.autoDeselectAncestors,
            autoSelectChildrens: this.autoSelectDescendants,
            autoDeselectChildrens: this.autoDeselectDescendants,
            refVal: this.refValue
        }
    },
    mounted() {
        //if (!this.valueCombining) {
        //    this.valueCombining = "ALL";
        //}
        this.refreshItems(this.code);

        if (this.flatType == null) {
            this.flatType = true;
        }
    },
    watch: {
        myValue: function (value) {
            if (value != this.value) {
                this.$emit('update:value', value);
            }
        },
        value: function (val) {
            if (val != this.myValue) {

                this.myValue = val;
            }
        }
    },
    methods: {
        refreshItems: function (code) {
            this.loading = true;
            this.$services.articles.getIdByCode({
                code: code,
                language: this.language,
                addAnySelector: this.addany
            })
                .then((data) => {
                    this.loading = false;
                    this.articleId = data;

                });
        }

    },
    template: `
      <div :id="guid">
      <template v-if="loading">
        <loading></loading>
      </template>
      <template v-else>
    
        <article-items-treeview-select
            :value.sync="myValue"
            :article="articleId"
            :placeholder="placeholder"
            :language="language"
            :guid="guid"
            :is-read-only="isReadOnly"
            :type="valueCombining"
            :flat="flatType"
            :addany="addany"
            :expanded="expandedType"
            :containerClass="cclass"
            :samevaluedisplay="samevaluedisplay"
            :auto-deselect-ancestors="autoDeselectParents"
            :auto-select-descendants="autoSelectChildrens"
            :auto-deselect-descendants="autoDeselectChildrens"
            :ref-val="refVal"
        ></article-items-treeview-select>

      </template>
      </div>
    `
});
